<template>
  <div>
    <div class="vx-row mb-base">
      <div class="vx-col w-full md:w-full flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false" color="#007BFF" loader="dots"></loading>
        <vs-alert active="true" class="">
          Click on the Pie charts to see distribution across time.
        </vs-alert>
        <gmap-map :center="center" :zoom="8" style="width: 100%; height: 1200px" :options="goptions" ref="mapRef">
          <gmap-polygon v-if="paths.length > 0" :paths="paths" :options="poptions" :editable="false" ref="polyline"></gmap-polygon>
          <gmap-cluster>
            <gmap-custom-marker :key="i" v-for="(m, i) in markers" :marker="m.position" @click.native="updateBarChart(m, i)" alignment="center">
              <donut-chart :data="m.pie" :location="m.region" :strains="labels" :key="i + 'd'"></donut-chart>
            </gmap-custom-marker>
          </gmap-cluster>
        </gmap-map>
      </div>
    </div>
    <div class="vx-row mb-base chart-insert">
      <div class="vx-col w-1/4 md:w-1/4 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <bar-chart :region="region" :type="'100%'"></bar-chart>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import GmapCustomMarker from 'vue2-gmap-custom-marker'

import DateSliderFilter from '../filters/DateSliderFilter.vue'
import DonutChart from './PieChart'
import BarChart from '@/components/charts/BarChart'

import covidApi from '@/http/requests/covid/index.js'
import regions from './data/ghana_regions.json'

export default {
  name: 'GeoMap',
  components: {
    Loading,
    GmapCluster,
    GmapCustomMarker,
    DateSliderFilter,
    DonutChart,
    BarChart
  },
  data() {
    return {
      labels: [],
      paths: [],
      markers: [],
      region: 'All',
      center: { lat: 7.9465, lng: -1.0232 },
      start: '2020-03-01',
      end: new Date().toISOString().slice(0, 10),
      isLoading: false,
      poptions: {
        strokeColor: '#777777',
        strokeOpacity: 0.9,
        strokeWeight: 1,
        fillColor: '#777777',
        draggable: false
      },
      goptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    }
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then(map => {
      map.panTo({ lat: 8.0, lng: -1.0232 })
    })
  },
  created() {
    this.readGeojson()
    this.getStrains()
  },
  methods: {
    getStrains() {
      const self = this
      this.labels = []
      covidApi
        .strains()
        .then(response => {
          self.labels = response.data
          self.getData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getData() {
      const self = this
      this.isLoading = true
      this.markers = []
      covidApi
        .sequence({ start: this.start, end: this.end })
        .then(response => {
          self.markers = response.data.sequence
          console.log(self.markers)
          self.isLoading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateBarChart(m) {
      this.region = m.region
    },
    readGeojson() {
      try {
        const mypaths = []
        regions.features.forEach(function(region) {
          const ftype = region.geometry.type
          const poly = []
          region.geometry.coordinates.map(function(c) {
            if (ftype === 'Polygon') {
              c.forEach(function(x) {
                poly.push({ lat: Number(x[1]), lng: Number(x[0]) })
              })
            } else if (ftype === 'MultiPolygon') {
              c.forEach(function(x) {
                x.forEach(function(y) {
                  poly.push({ lat: Number(y[1]), lng: Number(y[0]) })
                })
              })
            }
          })
          mypaths.push(poly)
        })
        this.paths = mypaths
      } catch (err) {
        console.log(err.message)
      }
    },
    periodChanged(args) {
      this.start = args.start
      this.end = args.end
      this.getData()
    }
  }
}
</script>
<style>
.chart-insert {
  margin-top: -800px;
  margin-left: 20px;
}
@media only screen and (max-width: 600px) {
  .chart-insert {
    display: none;
  }
}
</style>
